export default {
    init() {
        if (!checkCookie('cookieconsent')) {
            setTimeout(() => {
                $('#cookies').fadeIn(500);
            }, 1000);

            $('#close-cookie').click(() => {
                $('#cookies').fadeOut(500);
                setCookie('cookieconsent', 1, 365);
                campaign(250);
            });
        } else {
            campaign(2500);
        }

        function campaign(delay) {
            if (sessionStorage.getItem('campaignState') != 'dismissed') {
                setTimeout(() => {
                    $('#campaign').fadeIn(500);
                }, delay);
                $('#close-campaign').click(() => {
                    $('#campaign').fadeOut(500);
                    sessionStorage.setItem('campaignState', 'dismissed');
                });
            }
        }

        function checkCookie(cookie) {
            let cookieReturn = getCookie(cookie);
            if (cookieReturn != '') {
                return true;
            } else {
                return false;
            }
        }

        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            const expires = `expires=${d.toUTCString()}`;
            document.cookie = `${cname}=${cvalue};${expires};path=/`;
        }

        function getCookie(cname) {
            const name = `${cname}=`;
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
    }
};
